import React from "react";
import ReactSelect, {
  components as reactSelectComponents,
  GroupBase,
  MenuProps,
  Props,
} from "react-select";

import { subtleReactSelectStyles } from "ui/CreatableSelect";

// Re-exported so callers can type custom `styles` without importing react-select
export type { StylesConfig } from "react-select";

export type SingleSelectProps<T> = Props<T, false, GroupBase<T>> & {
  // Content pinned to the bottom of the menu, below the scrollable option list
  footer?: React.ReactNode;
};

// Menu component that renders the option list plus a footer passed through
// selectProps
function MenuWithFooter(props: MenuProps<any, false, GroupBase<any>>) {
  const { footer } = props.selectProps as unknown as {
    footer?: React.ReactNode;
  };
  return (
    <reactSelectComponents.Menu {...props}>
      {props.children}
      {footer}
    </reactSelectComponents.Menu>
  );
}

function SingleSelect<T>({
  styles,
  isClearable = false,
  footer,
  components,
  ...props
}: SingleSelectProps<T>): React.ReactElement {
  return (
    <ReactSelect<T, false, GroupBase<T>>
      styles={styles ?? subtleReactSelectStyles}
      isClearable={isClearable}
      components={footer ? { ...components, Menu: MenuWithFooter } : components}
      {...(footer !== undefined ? { footer } : {})}
      {...props}
    />
  );
}

export default SingleSelect;
